import * as React from 'react';
import { useProjectId } from 'owa-timestream-asset-sdk';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import type { ProjectId } from 'owa-timestream-types';
import { useAssetRegistry } from './useAssetRegistry';

export function useAssetDescriptors() {
    const projectId = useProjectId();
    const assetRegistry = useAssetRegistry();
    React.useEffect(() => {
        onOpenTimeStreamProject(projectId, assetRegistry.functionalAssets);
        return () => {
            onCloseCurrentTimeStreamProject(assetRegistry.functionalAssets);
        };
    }, [projectId, assetRegistry]);
}

function onOpenTimeStreamProject(projectId: ProjectId, functionalAssets: AssetDescriptor[]) {
    functionalAssets.forEach(asset => {
        if (asset.initializeAssetData) {
            asset.initializeAssetData(projectId);
        }
    });
}

function onCloseCurrentTimeStreamProject(functionalAssets: AssetDescriptor[]) {
    functionalAssets.forEach(asset => {
        if (asset.cleanupAssetData) {
            asset.cleanupAssetData();
        }
    });
}
